// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3hJGZ","footer":"ModalInfo_footer__1OusD"};